import React from "react";
import Context from "../../../Context";
import SVGCommode1 from "../../Misc/SvgIcons/SVGCommode1";
import SVGManual from "../../Misc/SvgIcons/SVGManual";
import SVGNuts from "../../Misc/SvgIcons/SVGNuts";
import SVGStorage from "../../Misc/SvgIcons/SVGStorage";
import SVGUrgentMail from "../../Misc/SvgIcons/SVGUrgentMail";
import SVGWorkdoc from "../../Misc/SvgIcons/SVGWorkdoc";
import UserNav from "../UserNav";
import IndexTile from "./IndexTile";
export default class Index extends React.Component {
  static contextType = Context;
  isAccessible = (essence) => {
    let access = this.context.user.classAccess[essence] || {};
    if (access.c || access.u || access.d) {
      return true;
    }
    return false;
  };
  render() {
    const allTiles = {
      manual: (
        <IndexTile
          key="manual"
          link="/manual/"
          icon={<SVGManual />}
          iconColor="primary"
          title="Руководства"
          description="Основная документация системы управления безопасностью"
          className="col-lg-6"
        />
      ),
      workdoc: (
        <IndexTile
          key="workdoc"
          link="/workdoc/"
          icon={<SVGWorkdoc />}
          iconColor="primary"
          title="Рабочая документация"
          description="Ваши докуемнты, входящие, исходящие, черновики"
          className="col-lg-6"
        />
      ),
      product: (
        <IndexTile
          key="product"
          link="/product/"
          icon={<SVGStorage />}
          iconColor="primary"
          title="Складские запасы"
          description="Перечень судовых складских позиций"
          className="col-lg-6"
        />
      ),
      element: (
        <IndexTile
          key="element"
          link="/element/"
          icon={<SVGNuts />}
          iconColor="primary"
          title="Структура СТСиК"
          description="Структурная схема узлов судна"
          className="col-lg-6"
        />
      ),
      library: (
        <IndexTile
          key="library"
          link="/library/"
          icon={<SVGCommode1 />}
          iconColor="primary"
          title="Библиотека"
          description="Общее хранилище файлов и документации"
          className="col-lg-6"
        />
      ),
      emergency_folder: (
        <IndexTile
          key="emergency_folder"
          link="/emergency_folder/"
          icon={<SVGUrgentMail />}
          iconColor="warning"
          title="Аварийная папка"
          description="Аварийная документация"
          className="col-lg-6"
        />
      ),
    };

    let availableTiles = [];

    Object.entries(allTiles).forEach(([key, tile]) => {
      if (this.isAccessible(key)) {
        availableTiles.push(tile);
      }
    });

    if (availableTiles.length < 6) {
      const { show } = this.context.user;
      const { passwordchange } = this.context.user.info.profile;
      availableTiles.unshift(
        <IndexTile
          key="profile"
          link="/profile/"
          icon={
            <div className="symbol symbol-50 ">
              {show.picture ? (
                <img alt="userpic" src={show.picture} />
              ) : (
                <span className="symbol-label font-size-h1">
                  {show.literal}
                </span>
              )}
              {passwordchange && <i className="symbol-badge bg-warning"></i>}
            </div>
          }
          iconColor="warning"
          title={show.name}
          description="Настройки профиля"
          className="col-lg-6"
        />
      );
    }

    return (
      <>
        <div className="d-flex align-items-center justify-content-center mh100">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 d-flex flex-column justify-content-between">
                <div className="text-center">
                  <img alt="" src={window.appConfig.clientLogo} />
                  <h3 className="font-weight-boldest  font-size-h4 font-size-h1-lg">
                    <div
                      className="text-dark-75 text-center break-all"
                      dangerouslySetInnerHTML={{
                        __html: window.appConfig.clientTitle,
                      }}
                    ></div>
                  </h3>
                  <div
                    className="text-muted break-all"
                    dangerouslySetInnerHTML={{
                      __html: window.appConfig.clientSlogan,
                    }}
                  ></div>
                </div>

                <div className="card card-custom gutter-b mt-5">
                  <div className="card-body">
                    <UserNav hideWorkdoc toggleFunction={() => false} />
                  </div>
                </div>
              </div>
              <div className="col-lg-8  ">
                <div className="row">{availableTiles}</div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
